export default function PhotoSlot({
    icon: Icon,
    label,
    sub,
    chip,
    ratio = "aspect-[16/11]",
    testId,
    image,
    alt = "",
    position = "center",
    fit = "cover",
}) {
    return (
        <div
            data-testid={testId}
            className={`group relative ${ratio} overflow-hidden border border-[#D4AF37]/25 bg-[#0B0B0C] shadow-[0_20px_50px_rgba(0,0,0,0.8)] transition-[border-color,box-shadow] duration-700 hover:border-[#D4AF37]/50 hover:shadow-[0_20px_60px_rgba(0,0,0,0.85),0_0_45px_rgba(212,175,55,0.12)]`}
        >
            <div className="absolute inset-0 transition-transform duration-[1600ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]">
                {image ? (
                    <>
                        <img
                            src={image}
                            alt={alt}
                            style={{ objectPosition: position }}
                            className={`absolute inset-0 h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`}
                        />
                        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_60%,rgba(5,5,5,0.4))]" />
                        <div className="noise-fill absolute inset-0" />
                    </>
                ) : (
                    <>
                        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,rgba(212,175,55,0.09),transparent_62%)]" />
                        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(212,175,55,0.05),transparent_40%,transparent_60%,rgba(154,123,56,0.06))]" />
                        <div className="noise-fill absolute inset-0" />
                        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_55%,rgba(5,5,5,0.55))]" />
                    </>
                )}
            </div>
            <div className="pointer-events-none absolute inset-3 border border-[#D4AF37]/12" />
            <span className="pointer-events-none absolute left-0 top-0 z-10 h-7 w-7 border-l-2 border-t-2 border-[#D4AF37]/80" />
            <span className="pointer-events-none absolute right-0 top-0 z-10 h-7 w-7 border-r-2 border-t-2 border-[#D4AF37]/80" />
            <span className="pointer-events-none absolute bottom-0 left-0 z-10 h-7 w-7 border-b-2 border-l-2 border-[#D4AF37]/80" />
            <span className="pointer-events-none absolute bottom-0 right-0 z-10 h-7 w-7 border-b-2 border-r-2 border-[#D4AF37]/80" />

            {!image && Icon && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-6 text-center">
                    <span className="flex h-16 w-16 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#050505]/60 text-[#D4AF37] transition-transform duration-700 group-hover:scale-110 sm:h-20 sm:w-20">
                        <Icon size={28} strokeWidth={1.2} />
                    </span>
                    <span className="font-mono-lux text-[10px] tracking-[0.4em] text-[#D4AF37]">
                        {label}
                    </span>
                    {sub && (
                        <span className="font-mono-lux max-w-[280px] text-[9px] leading-relaxed tracking-[0.22em] text-[#8A8A8E]">
                            {sub}
                        </span>
                    )}
                </div>
            )}

            {chip && (
                <span className="font-mono-lux absolute bottom-4 left-4 z-10 border border-[#D4AF37]/30 bg-[#050505]/80 px-3 py-1.5 text-[9px] tracking-[0.3em] text-[#D4AF37] backdrop-blur-sm">
                    {chip}
                </span>
            )}
        </div>
    );
}
